/* eslint-disable react/no-array-index-key */
import React from 'react';
import { renderToString } from 'react-dom/server';
import { CitedData, FormattedCitationContent } from '../types';
import { handleCitationNumberOnText } from '../utils';

interface CitationElementProps {
  content: FormattedCitationContent;
  keyPrefix?: string;
  citationNumber?: number;
}

export const CitationElement = ({
  content,
  keyPrefix,
  citationNumber = 1,
}: CitationElementProps) => (
  <span>
    {content.map(({ text, style }, index) => {
      if (index === 0) {
        text = handleCitationNumberOnText(text, citationNumber);
      }

      let el: JSX.Element = (
        <React.Fragment key={keyPrefix ? `${keyPrefix}__${index}` : `cite_el__${index}`}>
          {text}
        </React.Fragment>
      );

      if (!style) return el;
      // TODO: return only single element with CSS styles

      if (style.i) {
        el = <i>{el}</i>;
      }

      if (style.sup) {
        el = <sup>{el}</sup>;
      }

      if (style.sub) {
        el = <sub>{el}</sub>;
      }

      if (style.b) {
        el = <b>{el}</b>;
      }

      return el;
    })}
  </span>
);

export const citationsRichText = (
  citations: CitedData[],
  dataKey: 'full' | 'short' = 'full',
  needCitationWithLineBreak = true
) =>
  renderToString(
    <>
      {citations.map((citation) => (
        <React.Fragment key={citation.id}>
          <CitationElement content={citation[dataKey]} citationNumber={citation.citationNumber} />
          {needCitationWithLineBreak ? <br /> : null}
        </React.Fragment>
      ))}
    </>
  );

export const citationsRichTextWithParagraph = (
  citations: CitedData[],
  dataKey: 'full' | 'short' = 'full'
) =>
  renderToString(
    <>
      {citations.map((citation) => (
        <p key={citation.id}>
          <CitationElement content={citation[dataKey]} citationNumber={citation.citationNumber} />
        </p>
      ))}
    </>
  );
